import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Navigate } from 'react-router-dom';
import Register from '../components/Register';
import LoadingIndicator from '../components/LoadingIndicator';

const RegisterPage = () => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <LoadingIndicator />;
  }

  // If user is already authenticated, redirect to home
  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <div>
      <Register />
    </div>
  );
};

export default RegisterPage;
